import React, { useContext, useEffect, useState } from "react";
import "./AdvanceDashboard.css";

import Header from "../../Header/Header";
import { useNavigate } from "react-router-dom";

import Dashboard_LineChart from "./Dashboard_LineChart/Dashboard_LineChart";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendUp,
  faCartFlatbed,
  faChartSimple,
  faCircleUser,
  faTrash,
  faUser,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";

import { Table } from "react-bootstrap";
import { Context } from "../../../utils/context";
import { RoleId } from "../../../utils/common";
import { deleteData } from "../../../utils/api";

function AdvanceDashboard() {
  const navigate = useNavigate();

  const { getData, ErrorNotify } = useContext(Context);

  const [statusCounts, setStatusCounts] = useState({});
  const [chartData, setChartData] = useState({});
  const [data, setData] = useState([]);
  const [doctor, setDoctor] = useState({});
  const [user, setUser] = useState({});

  const getDataAll = async () => {
    const result = await getData("/admin/dashboard/dashboard-data");

    if (result?.success) {
      setStatusCounts(result?.data || {});
    }
  };

  const getDataDoctor = async () => {
    const result = await getData("/admin/dashboard/doctor-wallet");

    if (result?.success) {
      setDoctor(result?.data || {});
    }
  };

  const getChartData = async () => {
    const result = await getData("/admin/dashboard/sales-chart");

    if (result?.success) {
      setChartData(result?.data || {});
    }
  };

  const GetUser = async () => {
    const response = await getData("/common/auth/usersingleget");

    if (response?.success) {
      setUser(response?.data || {});
    }
  };

  const getnotification = async () => {
    const response = await getData("/admin/dashboard/admin-notification");

    if (response?.success) {
      setData(response?.data || []);
    }
  };

  const deletenotification = async (id) => {
    try {
      const response = await deleteData(`/admin/dashboard/notification/${id}`);

      if (response?.success) {
        ErrorNotify("Notification deleted successfully");
        await getnotification();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getDataAll();
    getChartData();
    GetUser();
    getDataDoctor();
    getnotification();
  }, []);

  return (
    <div className="main-advancedashboard">
      <section className="AdvanceDashboard">
        <div className="AdvanceDashboardTabs">
          <Header title="Dashboard" link="/masters/social_links" />
        </div>
      </section>

      {user?.role_id === RoleId.Doctor && (
        <div className="col-xl-12 col-lg-12">
          <div className="Main-Section-Advanced-Dashboard">
            <div className="row">
              <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                <div className="bucket-card-holder">
                  <div className="second_card_holder">
                    <h6 className="title">Wallet Amount</h6>

                    <div className="inner_div">
                      <div className="top_heading">
                        <div className="icon_holder">
                          <FontAwesomeIcon className="icon" icon={faWallet} />
                        </div>

                        <div className="text_holder">
                          <p className="text">Wallet Amount</p>
                        </div>
                      </div>

                      <div className="count_holder">
                        <p className="count">{doctor?.wallet?.amount || 0}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                <div
                  className="bucket-card-holder dashboard-clickable"
                  onClick={() => navigate("/subscription/appointment")}
                >
                  <div className="second_card_holder">
                    <h6 className="title">Appointment</h6>

                    <div className="inner_div">
                      <div className="top_heading">
                        <div className="icon_holder">
                          <FontAwesomeIcon
                            className="icon"
                            icon={faCircleUser}
                          />
                        </div>

                        <div className="text_holder">
                          <p className="text">Appointment</p>
                        </div>
                      </div>

                      <div className="count_holder">
                        <p className="count">
                          {doctor?.appointment?.length || 0}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bucket-card-holder">
                  <div className="second_card_holder">
                    <h6 className="title">Doctor Code</h6>

                    <div className="inner_div">
                      <div className="top_heading">
                        <div className="icon_holder">
                          <FontAwesomeIcon
                            className="icon"
                            icon={faCircleUser}
                          />
                        </div>

                        <div className="text_holder">
                          <p className="text">Doctor Code</p>
                        </div>
                      </div>

                      <div className="count_holder">
                        <p className="count">
                          {doctor?.doctor?.doctor_code || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {user?.role_id === RoleId.Admin && (
        <div className="Main-Section-Advanced-Dashboard">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-9">
                  <div className="row">
                    {/* Products */}
                    <div className="col-lg-4 col-sm-6 mb-3">
                      <div
                        className="bucket-card-holder dashboard-clickable"
                        onClick={() =>
                          user?.Store_Detail?.s_category?.is_restaurant_flow
                            ? navigate("/Foods/:id")
                            : navigate("/products")
                        }
                      >
                        <div className="second_card_holder">
                          <h6 className="title">Products</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  className="icon"
                                  icon={faChartSimple}
                                />
                              </div>

                              <div className="text_holder">
                                <p className="text">Total Products</p>
                              </div>
                            </div>

                            <div className="count_holder">
                              <p className="count">
                                {statusCounts?.total_products || 0}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Stock */}
                    <div className="col-lg-4 col-sm-6 mb-3">
                      <div
                        className="bucket-card-holder dashboard-clickable"
                        onClick={() => navigate("/product/product-stock")}
                      >
                        <div className="second_card_holder">
                          <h6 className="title">Stock</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  className="icon"
                                  icon={faArrowTrendUp}
                                />
                              </div>

                              <div className="text_holder">
                                <p className="text">Product Stock</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Customer Feedback */}
                    <div
                      className="col-lg-4 col-sm-6 mb-3"
                      onClick={() => navigate("/product/ratings/:id")}
                    >
                      <div className="bucket-card-holder dashboard-clickable">
                        <div className="second_card_holder">
                          <h6 className="title">Customer Feedback</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  className="icon"
                                  icon={faUser}
                                />
                              </div>

                              <div className="text_holder">
                                <p className="text">Total Messages</p>
                              </div>
                            </div>

                            <div className="count_holder">
                              <p className="count">
                                {statusCounts?.total_reviews || 0}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Today's Payment */}
                    <div className="col-lg-4 col-sm-6 mb-3">
                      <div className="bucket-card-holder">
                        <div className="second_card_holder">
                          <h6 className="title">Total</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  className="icon"
                                  icon={faWallet}
                                />
                              </div>

                              <div className="text_holder">
                                <p className="text">Today's Payment</p>
                              </div>
                            </div>

                            <div className="count_holder">
                              <p className="count">
                                {statusCounts?.todays_total || 0}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Customers */}
                    <div className="col-lg-4 col-sm-6 mb-3">
                      <div
                        className="bucket-card-holder dashboard-clickable"
                        onClick={() => navigate("/customers")}
                      >
                        <div className="second_card_holder">
                          <h6 className="title">Total Customer</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  className="icon"
                                  icon={faUser}
                                />
                              </div>

                              <div className="text_holder">
                                <p className="text">Total Customer</p>
                              </div>
                            </div>

                            <div className="count_holder">
                              <p className="count">
                                {statusCounts?.TotalCustomer || 0}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Sales */}
                    <div className="col-xl-8 col-lg-12 mb-3">
                      <div className="bucket-card-holder">
                        <div className="card-heading-holder second_card_holder">
                          <h6 className="title">Sales</h6>
                        </div>

                        <div className="card-number-holder text_holder">
                          <h3 className="count_text">
                            {chartData?.total || 0}
                          </h3>

                          <p>This month</p>
                        </div>

                        <div className="card-chart-holder">
                          <Dashboard_LineChart chartData={chartData?.data} />
                        </div>
                      </div>
                    </div>

                    {/* Today's Orders */}
                    <div
                      className="col-xl-4 col-lg-12 mb-3"
                      onClick={() => navigate("/orders/all-orders")}
                    >
                      <div className="bucket-card-holder dashboard-clickable">
                        <div className="card-heading-holder second_card_holder">
                          <h6 className="title">Today's Orders</h6>
                        </div>

                        <div className="card-number-holder">
                          <div className="icon_holder">
                            <FontAwesomeIcon
                              className="inner_icon"
                              icon={faCartFlatbed}
                            />
                          </div>

                          <div className="text_holder">
                            <div className="card-number-holder">
                              <h3 className="count_text">
                                {statusCounts?.total_Orders || 0}
                              </h3>

                              <p className="title_">Today Count</p>
                            </div>
                          </div>
                        </div>

                        <div className="card-table-holder">
                          <Table className="mb-0">
                            <tbody>
                              <tr>
                                <td>Processing Orders</td>
                                <td className="num">
                                  {statusCounts?.Processing_orders || 0}
                                </td>
                              </tr>

                              <tr>
                                <td>Preparing Orders</td>
                                <td className="num">
                                  {statusCounts?.Preparing || 0}
                                </td>
                              </tr>

                              <tr>
                                <td>Quality Check Orders</td>
                                <td className="num">
                                  {statusCounts?.OrderUnderQualityCheck || 0}
                                </td>
                              </tr>

                              <tr>
                                <td>Delivered Orders</td>
                                <td className="num">
                                  {statusCounts?.Delivered_orders || 0}
                                </td>
                              </tr>

                              <tr>
                                <td>Cancelled Orders</td>
                                <td className="num">
                                  {statusCounts?.Cancelled_orders || 0}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Notifications */}
                <div className="col-lg-3">
                  <div className="bucket-card-holder notification-card">
                    <div className="card-heading-holder">
                      <h6>Notifications</h6>
                    </div>

                    <div className="notification_list">
                      {data?.length > 0 ? (
                        data.map((item) => (
                          <div className="notification-box" key={item.id}>
                            <h6 className="notification_name">
                              {item?.name}

                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deletenotification(item.id);
                                }}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </span>
                            </h6>

                            <p className="notification_subname">
                              {item?.message}
                            </p>
                          </div>
                        ))
                      ) : (
                        <div className="no-notification">
                          <p>No notifications found.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdvanceDashboard;
